// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606051505/js/" + chunkId + "." + {"44":"c4ba78b2","225":"5b759f8e","481":"185caff9","486":"568a02e7","770":"a92d7723"}[chunkId] + ".0.06907063957600645.chunk.js";
};